import React, { FC } from 'react';
import LoginLanguage from 'components/LoginLanguage';
import Loader from 'components/UI/Loader';
import { getValueByName } from 'domains/project/model/utils/getbyLinkFile';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import cn from 'classnames';
import { useProjectTheme } from 'domains/project/model/selectors';
// import SnowBackground from 'components/UI/SnowBackground';
// import ChristmasCat from 'assets/christmasCat.png';
import NewYearParallax from 'components/NewYearParalax';
import css from '../styles.module.scss';
import { useProjectInfo } from '../../project/hooks';

const Container: FC = ({ children }) => {
  const { data: project, isLoading } = useProjectInfo();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isNewYear = useProjectTheme();

  return (
    <div
      className={cn(css.auth, {
        _isNewYear: isNewYear,
        _isLoading: isLoading,
      })}
    >
      {isNewYear && <NewYearParallax />}
      <div
        className={css.auth__bg}
        style={{
          backgroundImage: `url(${project ? project.background : ''})`,
        }}
      >
        {project && project.logo_medium && (
          <img
            className={css.auth__logo}
            src={project.logo_medium}
            alt="logo"
          />
        )}
        {project && project.slogan && (
          <div className={css.auth__slogan}>{project.slogan}</div>
        )}
      </div>
      <div className={css.auth__content}>
        {isLoading && (
          <div className={css.auth__loading}>
            <Loader transparent />
          </div>
        )}
        {/* {isNewYear && (
          <div className={css.auth__show}>
            <SnowBackground />
          </div>
        )} */}
        <div className={css.auth__form}>{project && children}</div>
        {project && (
          <div className={css.auth__additional}>
            {!isLoading && <LoginLanguage />}
            {getValueByName(project.files, 'offer') &&
              location.pathname === '/auth/sign-in' && (
                <a
                  className={css.auth__agreement}
                  href={
                    i18n.language === 'ru'
                      ? getValueByName(project.files, 'offer')
                      : getValueByName(project.files, 'offer_en') ||
                        getValueByName(project.files, 'offer')
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('form.common.offer__link__auth')}
                </a>
              )}
          </div>
        )}
        {/* 
          жалко котика, оставила, может в след году вернем
        {isNewYear && (
          <img
            src={ChristmasCat}
            alt="ChristmasCat"
            className={css.auth__newYearCat}
          />
        )} */}
      </div>
    </div>
  );
};

export default Container;
